import { InputLabel } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import { InputProps } from "@material-ui/core/Input";
import MenuItem from "@material-ui/core/MenuItem";
import Select, { SelectProps } from "@material-ui/core/Select";
import { makeStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import React from "react";
import { FormattedMessage } from "react-intl";

const useStyles = makeStyles(
  theme => ({
    focused: {
      backgroundColor: "#fff"
    },
    formControl: {
      "& label": {
        top: "-3px"
      },
      width: "100%"
    },
    menuItem: {
      backgroundColor: "transparent"
    },
    noLabel: {
      padding: theme.spacing(2, 1.5)
    },
    selectField: {
      backgroundColor: "transparent",
      padding: "6px 18px 0 12px"
    },
    selectRoot: {
      "&:focus": {
        backgroundColor: "transparent"
      }
    }
  }),
  { name: "SingleSelectFieldCustom" }
);

interface SingleSelectFieldCustomProps {
  choices: Array<{
    value: string;
    label: string | React.ReactNode;
  }>;
  className?: string;
  disabled?: boolean;
  error?: boolean;
  hint?: string;
  label?: string;
  name?: string;
  selectProps?: SelectProps;
  placeholder?: string;
  value?: string;
  InputProps?: InputProps;
  onChange(event: any);
}

export const SingleSelectFieldCustom: React.FC<SingleSelectFieldCustomProps> = props => {
  const {
    className,
    disabled,
    error,
    choices,
    value,
    onChange,
    hint,
    selectProps,
    placeholder
  } = props;
  const classes = useStyles(props);

  const choicesByKey: { [key: string]: string } =
    choices === undefined
      ? {}
      : choices.reduce((prev, curr) => {
          prev[curr.value] = curr.label;
          return prev;
        }, {});

  return (
    <FormControl
      className={classNames(classes.formControl, className)}
      error={error}
      disabled={disabled}
      id="searchBySKUNameBtn"
    >
      <InputLabel>Search by SKU / Name</InputLabel>
      <Select
        className={classes.selectField}
        variant="standard"
        disableUnderline
        fullWidth
        renderValue={choiceValue =>
          choiceValue ? choicesByKey[choiceValue.toString()] : placeholder
        }
        value={value || ""}
        classes={{ root: classes.selectRoot }}
        onChange={onChange}
        {...selectProps}
      >
        {choices?.length > 0 ? (
          choices.map(choice => (
            <MenuItem
              id={`${choice.value}Btn`}
              placeholder="Search by SKU / Name"
              className={classes.menuItem}
              data-test="selectFieldOption"
              data-test-id={choice.value}
              value={choice.value}
              key={choice.value}
            >
              {choice.label}
            </MenuItem>
          ))
        ) : (
          <MenuItem
            placeholder="Search by SKU / Name"
            className={classes.menuItem}
            data-test="selectFieldOption"
            data-test-disabled
            disabled={true}
            disableRipple={true}
          >
            <FormattedMessage defaultMessage="No results found" />
          </MenuItem>
        )}
      </Select>
      {hint && <FormHelperText>{hint}</FormHelperText>}
    </FormControl>
  );
};
SingleSelectFieldCustom.displayName = "SingleSelectFieldCustom";
export default SingleSelectFieldCustom;
